define(
            ['jquery', 'c21', 'c21/log', 'c21/PropertyPhotoPaginator', 'c21/listhub', 'c21/ajax', 'c21/Collapsasaurus', 'c21/track', 'c21/charts/ChartMaster', 'c21/internationalization', 'photoswipe', 'c21/modalWindow', 'mortgageCalc',     'jqueryenter', 'Modernizr', 'bing',   'c21/maps', 'c21/listTrac'],
   function ($,  c21,   $log,      PropertyPhotoPaginator,       listhub,       ajax,       Collapsasaurus,       Track,       ChartMaster,              internationalization,       photoswipe,   ModalWindow,       MortgageCalculator, jqueryenter,   Modernizr,   BingMaps, C21Maps, listTrac) {
   "use strict";

   return function () {
      // Commenting out certain methods atm so we can move ahead
      // FIXME: Remove this flag after page is complete
      /* jshint unused: false */

      var self = this;
      var m_listingkey = "";
      var m_listingSourceId = "";
      var m_city = "";
      var m_state = "";
      var m_zip = "";
      var m_listingMLS = "";
      var m_directionsInitialized = false;
      var jPropDetailsContainer = null;
      var m_propertyPhotoPaginator;
      var m_jViewFullScreen = null;
      var _initiateFullScreenViewer = null;
      var mMap = null;
      var mMapDirections = null;
      var dDirectionsManager = null;
      var m_intervalFSV;
      var $propertyThumbnail;
      var imageCounter;
      var iIndex;
      function setPropertyId(listingkey) {
         m_listingkey = listingkey;
      }

      function setPropertySourceId(listingSourceID) {
         m_listingSourceId = listingSourceID;
      }

      function setCity(val) {
         m_city = val;
      }

      function setState(val) {
         m_state = val;
      }

      function setZip(val) {
         m_zip = val;
      }

      function setMLS(val) {
         m_listingMLS = val;
      }

      /**
       * Initialize the mortgage calculator modal
       *
       */
      function initializeMortgageCalc() {
         // open modal
         $(".mortgageCalcLink").click(function () {
            var propertyId = $("#propertyDetails").data('propid');
            Track.doEvent('PDP', 'Recalculate Mortgage');
            var jTemplate = $("#mortgageCalcTemplate");
            var model = {
            };
            ModalWindow.modal(internationalization.getString('Recalculate Mortgage'), { template: jTemplate.html(), model: model, size: 'sm' });

            // Prevent the default behavior of the mousewheel event on input-number elements
            $('#mcTop :input[type=number]').on('mousewheel', function(e){
               e.preventDefault();
            });

            // calculate mortgage
            $("#mortCalculate").click(function () {
               Track.doEvent('PDP', 'Mortgage Calculator', 'Calculate');
               var calc = new MortgageCalculator();
               calc.calcMortgageTop();
            });
         });
      }

      function initializeFSV() {
         $("#Gallery").click(function() {
            listTrac.doEvent('gallery', jPropDetailsContainer);
         });

         //Assign an index for each slide
         _initiateFullScreenViewer = $(".propImageLarge");
         _initiateFullScreenViewer.on('click', function() {
            $propertyThumbnail = $('.propertyThumbnail');

            if($propertyThumbnail[0].hasAttribute('data-index')) {
               //do nothing
            } else {
               imageCounter = -1;
               $.each($propertyThumbnail, function(key, value) {
                  $(value).attr("data-index", imageCounter);
                  imageCounter++;
               });
            }

            iIndex = parseInt($('.selectedThumbnail img').attr('data-index'));
            require(['photoswipe', 'photoswipeui'], function (PhotoSwipe, PhotoSwipeUI) {
               var options = {
                     index: iIndex,
                     history: false,
                     scaleMode: 'fit',
                     allowOverscale: true,
                  },
                  iSizeRequired = 0,
                  iSizeGathered = 0,
                  jLoadingBar,
                  jLoadingCount,
                  jLoadingMax,
                  fFetchImageDims = function(i) {
                     $("<img>").load(function() {
                        window.slideshowData[i].w = this.width;
                        window.slideshowData[i].h = this.height;
                        iSizeGathered++;
                        fUpdateBar();
                     }).attr('src', window.slideshowData[i].src);
                  },
                  fUpdateBar = function() {
                     jLoadingCount.text(iSizeGathered);
                     jLoadingMax.text(iSizeRequired);
                     jLoadingBar.css({width: (iSizeGathered / iSizeRequired * 100) + '%'});
                  };
               //Count how many photos we have
               for (var i = 0; i < window.slideshowData.length; i++) {
                  if (window.slideshowData[i].w === 0) {
                     iSizeRequired++;
                     fFetchImageDims(i);
                  }
               }
               if (iSizeRequired > 0) {
                  var jLoading = $('#slideshowLoading');
                  if (!jLoading.length) {
                     jLoading = $("<div id='slideshowLoading'>");
                     jLoading.appendTo($('body'));
                  }
                  jLoading.html('');
                  jLoading.append($("<div class='close'>").click(function() {
                     jLoading.hide();
                     clearInterval(m_intervalFSV);
                  }));
                  jLoading.append($('<div class="loading-message">').html('Loading...'));
                  jLoadingBar = $('<div class="loading-bar">');
                  jLoadingCount = $('<span>');
                  jLoadingMax = $('<span>');
                  jLoading.append($('<div class="loading-area">').append(jLoadingBar).append($('<div class="loading-count">').append(jLoadingCount).append(" / ").append(jLoadingMax)));
                  fUpdateBar();
                  jLoading.show();
               }
               m_intervalFSV = setInterval(function() {
                  if (iSizeRequired === iSizeGathered) {
                     clearInterval(m_intervalFSV);
                     $('#slideshowLoading').hide();
                     var pswp = new PhotoSwipe($(".pswp").get(0), PhotoSwipeUI, window.slideshowData, options);
                     pswp.init();
                  }
               }, 100);
            });
         });
      }

      /**
       * Check if the Realbiz FSV Dynamic JS is available
       *
       */
      function isRealbizDynamicFSVEnabled() {
         // Disable FSV in IE8 and IE9
         if (navigator.appVersion.indexOf("MSIE 8.") !== -1 || navigator.appVersion.indexOf("MSIE 9.") !== -1) {
            return false;
         }

         if (typeof(window.startslideshow) === "function") {
            return true;
         }
         return false;
      }

      function onLargeImageClick() {
         if(!m_jViewFullScreen.is(":visible")) {
            return;
         }
         Track.doEvent('PDP', 'Realbiz Full Screen', 'Viewer Opened');
      }

      function enableFullScreenViewer() {
         $("#largeImageContainer").click(onLargeImageClick);

         $("#Gallery").css("cursor", "pointer");

         // Call this function which is in the Realbiz dynamic guid JS
         if (typeof(window.addElement) === "function") {
            window.addElement();
         }
         if (typeof(window.startslideshow) === "function") {
            window.startslideshow();
         }


//         if (Modernizr.touch) {
//            $(".img").addClass("hover");
//            $(".img").click(function (e) {
//               if (typeof(window.startslideshow) === "function") {
//                  window.startslideshow();
//               }
//            });
//            $(".close-overlay").click(function (e) {
//               e.preventDefault();
//               e.stopPropagation();
//               if ($(this).closest(".img").hasClass("hover")) {
//                  $(this).closest(".img").removeClass("hover");
//               }
//            });
//         } else {
//            $(".img").mouseenter(function () {
//               $(this).addClass("hover");
//            }).mouseleave(function () {
//               $(this).removeClass("hover");
//            });
//            $(".img").click(function () {
//               $(this).addClass("hover");
//               window.startslideshow();
//            });
//         }
      }

      function initializeDisplay() {
         var jHighSchools = $(".highSchoolSection"),
            jMiddleSchools = $(".middleSchoolSection"),
            jElementarySchools = $(".elementarySchoolSection"),
            jTypeContainer = $("#schoolsTypeContainer"),
            jExpander = $("#showAllSchoolsContainer"),
            sAddress = $("#schoolHouseAddress").text();

         $('.collapsasaurus').each(function () {
            new Collapsasaurus($(this), 12, {
               expandText: '&hellip;' + internationalization.getString('View More'),
               collapseText: '< ' + internationalization.getString('less')
            });
         });

         jHighSchools.filter(":gt(2)").hide();
         jMiddleSchools.filter(":gt(2)").hide();
         jElementarySchools.filter(":gt(2)").hide();
         if (jHighSchools.length > 3 || jMiddleSchools.length > 3 || jElementarySchools.length > 3) {
            jExpander.click(function () {
               Track.doEvent('Schools', 'PDP Hybrid Page', 'Show all attending schools');
               jExpander.hide();
               jHighSchools.show();
               jMiddleSchools.show();
               jElementarySchools.show();
            });
            jTypeContainer.append(jExpander);
            jExpander.show();
         }
      }

      /* Initialize Translator for Listing Description */
      function initializeInternationalization() {
         var websiteCode = window.websiteCode;
         if (websiteCode !== null && websiteCode !== "" && websiteCode === "ESP") {
            //internationalization.translatePropertyDesc('en', 'es', $('#TRACKING_PROPERTY_ID').val(), 0, function(result) {$('#propertyDescCollapse').html(result);});
            //$('.translateDescription.es').hide();
         } else {
            $('.translateDescription.en').hide();
            $('.translateDescription.es').hide();
         }
         $('.translateDescription.en').hide();
         $('.translateDescription.en').click(function () {
            internationalization.translatePropertyDesc('es', 'en', $('#TRACKING_PROPERTY_ID').val(),
               function (result) {
                  $('#propertyDescCollapse').html(result);
                  new Collapsasaurus($('#propertyDescCollapse'), 12, {
                     expandText: '&hellip;' + internationalization.getString('View More'),
                     collapseText: '< ' + internationalization.getString('less')
                  });
               }
            );
            $('.translateDescription.en').hide();
            $('.translateDescription.es').show();
         });
         $('.translateDescription.es').click(function () {
            internationalization.translatePropertyDesc('en', 'es', $('#TRACKING_PROPERTY_ID').val(),
               function (result) {
                  $('#propertyDescCollapse').html(result);
                  new Collapsasaurus($('#propertyDescCollapse'), 12, {
                     expandText: '&hellip;' + internationalization.getString('View More'),
                     collapseText: '< ' + internationalization.getString('less')
                  });
               }
            );
            $('.translateDescription.es').hide();
            $('.translateDescription.en').show();
         });
      }

      function initializeVirtualTour() {
         $("#showVirtualTour").on("click", function (e) {
            e.preventDefault();

            if (window.virtualTours.length === 1) {
               showVirtualTour(window.virtualTours[0].url);
            } else if (window.virtualTours.length > 1) {
               var jTemplate = $("#virtualToursTemplate");
               var model = {
                  tours: window.virtualTours
               };
               ModalWindow.modal(internationalization.getString("Virtual Tours"), { template: jTemplate.html(), model: model, size: "lg" });
            }
         });

         $(document).on("click", "ul#virtualTours a", function (e) {
            e.preventDefault();
            showVirtualTour($(this).attr("href"));
         });
      }

      function showVirtualTour(sTour) {
         trackListing("Virtual");
         listTrac.doEvent('vTour', jPropDetailsContainer);
         window.open(sTour, "C21VirtualTour", "width=1024, height=768, menubar=no");
      }

      function showFloorPlans(aFloorplans) {
         // FIXME: Add modalWindows
         //modalWindows.openFloorplans(aFloorplans);
         trackListing("Floor");
      }

      function showDownloads(aDownloads) {
         // FIXME: Add modalWindows
         //modalWindows.openDownloads(aDownloads);
      }

      function printListing() {
         // Put the graphs in the correct position
         $('.cyberVerticalGraph .bar').trigger('print');
         $('.demoHorizontalData .nearbyBar').trigger('print');
         $('.demoHorizontalData .nearbyBarAlt').trigger('print');
         window.print();
         listTrac.doEvent('printListing', jPropDetailsContainer);
         trackListing("PropPrinted");
      }

      /**
       * ListHub: Track C21 Listing
       *
       */
      function trackC21Listing(listingGUID, type) {
         /* Do list hub tracking */
         switch (type) {
            case "Map":
               listhub.doTrackingC21(listingGUID, 'PROPERTY_MAP_CLICKED');
               break;
            case "ContactSA":
            case "ContactOff":
               listhub.doTrackingC21(listingGUID, 'QUESTION');
               break;
            case "Detail":
               listhub.doTrackingC21(listingGUID, 'VIEWED_ON_CHANNEL');
               break;
            case "Dir":
               listhub.doTrackingC21(listingGUID, 'DRIVING_DIRECTIONS_CLICKED');
               break;
            case "RetSearch":
               listhub.doTrackingC21(listingGUID, 'SEARCH_DISPLAY');
               break;
            case "Saved":
               listhub.doTrackingC21(listingGUID, 'LISTING_SAVED');
               break;
            case "Virtual":
               listhub.doTrackingC21(listingGUID, 'VIRTUAL_TOUR_CLICKED');
               break;
            case "Slides":
               listhub.doTrackingC21(listingGUID, 'SLIDESHOW_CLICKED');
               break;
            case "Floor":
               listhub.doTrackingC21(listingGUID, 'FLOORPLANS_CLICKED');
               break;
            case "Email":
               listhub.doTrackingC21(listingGUID, 'SHARED');
               break;
            case "PropPrinted":
               listhub.doTrackingC21(listingGUID, 'PRINT_MEDIA_CLICKED');
               break;
            default:
               listhub.doTracking(listingGUID, type);
               break;
         }
      }

      /**
       * ListHub: Track Other Listing - Non C21 Listing only
       *
       */
      function trackOtherListing(listingkey, type) {
         /* Do list hub tracking */
         switch (type) {
            case "Map":
               listhub.doTracking(listingkey, 'PROPERTY_MAP_CLICKED');
               break;
            case "ContactSA":
            case "ContactOff":
               listhub.doTracking(listingkey, 'QUESTION');
               break;
            case "Detail":
               listhub.doTracking(listingkey, 'VIEWED_ON_CHANNEL');
               break;
            case "Dir":
               listhub.doTracking(listingkey, 'DRIVING_DIRECTIONS_CLICKED');
               break;
            case "RetSearch":
               listhub.doTracking(listingkey, 'SEARCH_DISPLAY');
               break;
            case "Saved":
               listhub.doTracking(listingkey, 'LISTING_SAVED');
               break;
            case "Virtual":
               listhub.doTracking(listingkey, 'VIRTUAL_TOUR_CLICKED');
               break;
            case "Slides":
               listhub.doTracking(listingkey, 'SLIDESHOW_CLICKED');
               break;
            case "Floor":
               listhub.doTracking(listingkey, 'FLOORPLANS_CLICKED');
               break;
            case "Email":
               listhub.doTracking(listingkey, 'SHARED');
               break;
            case "PropPrinted":
               listhub.doTracking(listingkey, 'PRINT_MEDIA_CLICKED');
               break;
            default:
               listhub.doTracking(listingkey, type);
               break;
         }
      }

      function trackListing(type) {
         var listingkey = null;
         try {
            listingkey = m_listingkey.replace("C21", "");
         } catch (err) {
            $log.error("Could not track listing - listing key not defined." + err.message);
            return;
         }

         try {
            if (m_listingkey.indexOf("CBR") < 0 && m_listingkey.indexOf("ERA") < 0 && m_listingkey.indexOf("LCE") < 0) {
               //only C21 listing tracking
               /* Do internal tracking */
               ajax.report({
                  url: "/reporting/listing",
                  data: "id=" + listingkey + "&type=" + type
               });


               // Set the source id (guid) for tracking a C21 listing
               if (m_listingkey.indexOf("C21") >= 0) {
                  trackC21Listing(m_listingSourceId, type);
               } else {
                  trackOtherListing(m_listingSourceId, type);
               }
            }
         } catch (err) {
            $log.error("Could not track listing - error during request.", err);
         }

      }

      function initializeMap() {
         var jHolder = $('#resultMap'),
             jLocHolder = $('#propertyDetails'),
             location;

         if (mMap !== null && !jHolder.hasClass('hasMap')) {
            mMap = null;
         }
         if (mMap === null && jHolder.is(":visible")) {
            jHolder.addClass('hasMap');
            location = new BingMaps.Location(jLocHolder.data("latitude"), jLocHolder.data("longitude"));

            var opts = {
               credentials: C21Maps.bingmapCredentials,
               center: location,
               showDashboard: false,
               mapTypeId: BingMaps.MapTypeId.auto,
               zoom: 13,
               customizeOverlays: true,
               enableSearchLogo: false,
               disableUserInput: true
            };

            mMap = new BingMaps.Map(jHolder.get(0), opts);
            mMap.entities.push(new BingMaps.Pushpin(location, {
               icon: "/images/eco/icons/pushpins/dot.png",
               width: 50,
               height: 50
            }));

            mMapDirections = new BingMaps.Map($('#resultMapDirections').get(0), opts);
            mMapDirections.entities.push(new BingMaps.Pushpin(location, {
               icon: "/images/eco/icons/pushpins/dot.png",
               width: 50,
               height: 50
            }));
         }

         $('#itineraryContainer').on('click', 'ul.disambiguationList a', function (e) {
            e.preventDefault();
            var sFromLocation = $(this).text();

            $('#navAddress').val(sFromLocation);
            $('#itineraryContainer').slideUp(function () {
               $(this).html('');
               $('.drivingDirections form').submit();
            });
         });

         $(".action-get-direction").click(function() {
            $("#propMapDirections").addClass("show-directions");
            $("body").addClass("modal-open");
            trackListing('Map');
            listTrac.doEvent('drivingDirections', jPropDetailsContainer);
            Track.doEvent('PDP', 'View Map');
            Track.doEventByPropTypeLabel('indirect', 'view-map', $("#propertyDetails").data("brand-cd"));
            initializeDirections();
         });

         $(".action-close-directions").click(function() {
            $("#propMapDirections").removeClass("show-directions");
            $("body").removeClass("modal-open");
         });
      }

      function initializeDirections() {
         if (!m_directionsInitialized) {
            m_directionsInitialized = true;

            setTimeout(function() {

               BingMaps.loadModule('Microsoft.Maps.Directions', { callback: function () {
                     dDirectionsManager = new BingMaps.Directions.DirectionsManager(mMapDirections);
                     dDirectionsManager.setRenderOptions({
                        itineraryContainer: document.getElementById('itineraryContainer')
                     });

                     dDirectionsManager.showInputPanel('inputPanel');

                     var endWaypoint = new Microsoft.Maps.Directions.Waypoint({
                        address: $.trim($('.propertyTitleLine').text().replace(/ +/g, ' ')),
                     });
                     dDirectionsManager.addWaypoint(endWaypoint);
               }})
              }, 1);
         }
      }

      function initializeVideoPlayer() {
         $('#videoModal').on('show.bs.modal', function (e) {
            var sVideoId = $(e.relatedTarget).data('embed-url').split('=')[1],
                sEmbedUrl = "https://www.youtube-nocookie.com/embed/" + sVideoId + "?autoplay=1";
            $('iframe', this).attr('src', sEmbedUrl);
         });

         $('#videoModal').on('hide.bs.modal', function (e) {
            $('iframe', this).attr('src', '');
         });
      }

      function setPreview() {
         /* jshint scripturl: true */

         $("a").each(function (i, el) {
            /* jshint scripturl: true */
            if (el.href[0] !== '#' && el.href.substring(0, 11) !== 'javascript:') {
               el.href = 'javascript: PropertyDetails.previewWarning();';
            }
         });
         $("#searchButton").unbind('click').attr('href', 'javascript: PropertyDetails.previewWarning();');
         $("#searchText").attr('disabled', 'disabled');
         $(".Standard3Lane #BodyLeftLane .LaneTitle").hide();
         $("#listContainer a").attr("href", "javascript:void(0);");
      }

      function previewWarning() {
         window.alert("This is not available in preview mode.");
      }

      function openHomeProtectionModal() {
         $("#PropertyHPPModalDiv").show();
      }

      function closeHomeProtectionModal() {
         $("#PropertyHPPModalDiv").hide();
      }

      function initializeActions() {
         //$(".action-primary-print").click(printListing);
      }

      function initializeForms() {
         try {
            $('input, textarea').placeholder();
         } catch( err ) {
            // No error if placeholder is not there.
         }
      }

      function initializePrint() {
         $('a.action-primary-print').on('click', function (e) {
            e.preventDefault();
            printListing();
         });
      }

      function initializeScrollHeader() {
         $(window).on('scroll', function () {
            if ($(window).scrollTop() > 400) {
               $('.navbar-fixed-on-scroll').addClass('scrolled');
            } else {
               $('.navbar-fixed-on-scroll').removeClass('scrolled');
            }
         });
         $('#scrollToContact').click(function(event) {
            $('html, body').animate({scrollTop:'150'});
            event.preventDefault();
            return 0;
         });
      }

      function initializeMobile() {
         $("#propertyContactMobileTrigger").click(function(event) {
            var propertyId = $("#propertyDetails").data('propid');
            Track.doEvent('PDP', 'Contact');
            ModalWindow.contactProperyModal(propertyId);
            event.preventDefault();
         });
      }

      function initialize() {
         jPropDetailsContainer = $("#propertyDetails");

         initializeActions();
         initializeVideoPlayer();
         initializeDisplay();
         initializeInternationalization();
         initializeFSV();
         initializeMortgageCalc();
         initializeForms();
         initializePrint();
         initializeVirtualTour();
         initializeScrollHeader();
         initializeMobile();

         ChartMaster.initialize();
         //OtherHomesYouMightLike.initialize();

         m_propertyPhotoPaginator = new PropertyPhotoPaginator();
         m_propertyPhotoPaginator.initialize();

         //PropertyVideoPaginator.initialize();
         //SchoolsData.initialize();
         setPropertyId($('#TRACKING_PROPERTY_ID').val());
         setPropertySourceId($('#TRACKING_PROPERTY_SOURCE_ID').val());
         setCity($('#TRACKING_PROPERTY_CITY').val());
         setState($('#TRACKING_PROPERTY_STATE').val());
         setZip($('#TRACKING_PROPERTY_ZIP').val());
         setMLS($("#propertyDetails").data('mls'));

         trackListing('VIEWED_ON_CHANNEL');

         if($('body').hasClass('pageEcoIdx')) {
            Track.doEvent('indirect', 'pdp-page-view', 'IDX');
         } else {
            Track.doEvent('indirect', 'pdp-page-view', 'ECO');
         }
      }

      initializeMap();

      $(document).ready(initialize);

      return {
         previewWarning: previewWarning,
         setPreview: setPreview,
         showFloorPlans: showFloorPlans,
         showDownloads: showDownloads,
         setPropertyId: setPropertyId,
         openHomeProtectionModal: openHomeProtectionModal,
         closeHomeProtectionModal: closeHomeProtectionModal
      };
   };
});
